


import { useEffect, useState, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNotify } from "../../context/NotifyContext";
import Main from "../Main";

import {
  statusCheckAepsAccount,
  getAepsOnboardAccount,
  merchantRegistrationEkyc,
  startMerchantKyc,
  activateAeps,
  verifyAepsOtp,
  sendAepsOtpMerchant,
  aepsRegistrationVerify,
  aepsRegistration,
  merchantDailyAuthCheck,
} from "../../api/aepsApi";

import { useFingerprintCapture } from "../../hooks/useFingerprintCapture";
import { getLocation } from "../../components/Navigator/Navigator";
import FingerprintModal from "../../hooks/FingerprintModal";
import { updateUserInfo } from "../../features/authSlice";
import OtpModal from "./OtpModal";
import Bank5Modal from "./Bank5Modal";
import { Avatar } from "@mui/material";
import { Assessment } from "@mui/icons-material";
import PageHeader from "./PageHeader";
import { useNavigate, useSearchParams } from "react-router-dom";

const normalizeBank = (bank) => {
  if (!bank) return "";
  return bank.toString().trim().toLowerCase();
};

const getBankData = (onboard, bank) => {
  if (!onboard?.banks) return {};

  const key = Object.keys(onboard.banks).find(
    (b) => normalizeBank(b) === normalizeBank(bank)
  );

  return onboard.banks[key] || {};
};


const AEPSDashboard = () => {
  const { notify } = useNotify();
  const dispatch = useDispatch();
  const { userInfo, location: savedLocation } = useSelector((s) => s.auth);
const navigate = useNavigate()
  const { captureFingerprint, fingerLoading } = useFingerprintCapture();

  const [onboard, setOnboard] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
  const [selectedBank, setSelectedBank] = useState("");
  const [otp, setOtp] = useState("");
  const [showBank5Modal, setShowBank5Modal] = useState(false);
  const [annualIncome, setAnnualIncome] = useState("");
  const [natureBusiness, setNatureBusiness] = useState("");
const [otpTimerActive, setOtpTimerActive] = useState(false);
const [openOtp, setOpenOtp] = useState(false);
const [timer, setTimer] = useState(0);

const bankData = getBankData(onboard, selectedBank);
const bankKyc = bankData?.kyc || {};
const bankRegister = bankData?.registration || {};

const flow = {
  onboard:
    onboard?.onboard?.status === "SUCCESS" ||
    onboard?.onboardStatus === "SUCCESS",

  kyc: bankKyc?.status === "SUCCESS",
  register: bankRegister?.status === "SUCCESS"
};


  // ================= FETCH ONBOARD DATA =================
  const fetchAepsOnboardData = async () => {
    try {
      setLoading(true);
      const res = await getAepsOnboardAccount();
      if (res?.success) {
        setOnboard(res.data || {});
      }
    } catch {
      notify("Failed to fetch onboard data", "error");
    } finally {
      setLoading(false);
    }
  };





useEffect(() => {
  if (!onboard) return;

  // const activeBanks = Object.keys(onboard?.paysprintbank || {}).filter(
  //   b => onboard.paysprintbank[b] === 1
  // );

  const activeBanks = Object.keys(onboard?.paysprintbank || {})
  .filter(b => onboard.paysprintbank[b] === 1)
  .map(b => normalizeBank(b));


 const bankFromUrl = normalizeBank(searchParams.get("selectedbank"));


  let finalBank =
    bankFromUrl && activeBanks.includes(bankFromUrl)
      ? bankFromUrl
      : onboard.finalPipe || activeBanks[0] || "";

  if (!finalBank) return;

setSelectedBank(normalizeBank(finalBank));


  // Only set URL if missing (avoid loop)
  if (!bankFromUrl) {
    setSearchParams({ selectedbank: finalBank }, { replace: true });
  }

}, [onboard]); // ✅ ONLY onboard dependency



//   const bankKyc = onboard?.banks?.[selectedBank]?.kyc;
// const bankRegister = onboard?.banks?.[selectedBank]?.registration;

// const bankKyc = onboard?.banks?.[selectedBank]?.kyc || {};
// const bankRegister = onboard?.banks?.[selectedBank]?.registration || {};





// const flow = {
//   onboard: onboard?.onboard?.status === "SUCCESS",
//   kyc: bankKyc?.status === "SUCCESS",
//   register: bankRegister?.status === "SUCCESS",
// };

// const handleBankChange = (bank) => {
//   setSelectedBank(bank);
//   setSearchParams({ selectedbank: bank }, { replace: true });
// };

const handleBankChange = (bank) => {
  const cleanBank = normalizeBank(bank);
  setSelectedBank(cleanBank);
  setSearchParams({ selectedbank: cleanBank }, { replace: true });
};




  const handleStatusCheck = async () => {
  if (!selectedBank) return notify("Select Bank", "error");

  try {
    setActionLoading(true);

   
    const payload = {
      merchantcode: userInfo.userName,
      pipe: selectedBank,
 
    };

    const res = await statusCheckAepsAccount(payload);

    if (res.success) {
      notify(res?.message || "Status Successfully", "success");
  fetchAepsOnboardData();

    } else {
      notify(res.message, "error"); // 🔥 Paysprint error show
    }
  } catch (err) {
    notify("Onboarding Failed", "error");
  } finally {
    setActionLoading(false);
  }
};


  const handleStartAuth = async () => {
  if (!selectedBank) return notify("Select Bank", "error");

  try {
    setActionLoading(true);

    let location = savedLocation || (await getLocation());
    if (!location) return notify("Location required", "error");

    const pidData = await captureFingerprint(selectedBank);
    if (!pidData) return notify("Fingerprint failed", "error");

    const payload = {
      merchantcode: userInfo.userName,
      pipe: selectedBank?.trim().toLowerCase(),
      pidData,
      latitude: location.latitude,
      longitude: location.longitude,
    };

    const res = await merchantDailyAuthCheck(payload);

  if (res.success) {
  notify(res.message || "AEPS Activated Successfully", "success");
  await fetchAepsOnboardData();
} else {
  notify(res.message || "Authentication Failed", "error");
}

  } catch (err) {
    notify(err.message || "Onboarding Failed", "error");
  } finally {
    setActionLoading(false);
  }
};
  // ================= ONBOARD START =================
  const handleStartOnboarding = async () => {
    try {
      setActionLoading(true);
      const payload = {
      merchantId:userInfo._id,
      }
      const res = await startMerchantKyc(payload);
      if (res.success) {
        window.open(res.url, "_blank");
        notify("Onboarding started", "success");
      }
      else {
         notify(res?.message || "Onboarding started", "success");
      }
    } catch {
      notify("Onboarding failed", "error");
    } finally {
      setActionLoading(false);
    }
  };


  // ================= REGISTRATION ACTION =================
const handleStartRegistration = async () => {
  if (!selectedBank) return notify("Select Bank", "error");

  try {
    setActionLoading(true);

    let location = savedLocation || (await getLocation());
    if (!location) return notify("Location required", "error");

    const pidData = await captureFingerprint(selectedBank);
    if (!pidData) return notify("Fingerprint failed", "error");

    const payload = {
      merchantcode: userInfo.userName,
      pipe: selectedBank,
      pidData,
      latitude: location.latitude,
      longitude: location.longitude,
    };

    const res = await merchantRegistrationEkyc(payload);

   if (res.success) {
  notify(res.message, "success");
    await fetchAepsOnboardData();
} else {
  notify(res.message, "error");
}

  } catch (err) {
    console.error(err);
    notify(err?.message || "Registration Failed", "error");
  } finally {
    setActionLoading(false);
  }
};


  // ================= SEND OTP / ACTIVATE =================
  // const handleSendAepsOtp = async () => {
  //   if (!selectedBank) return notify("Select Bank", "error");
  //   try {
  //     setActionLoading(true);

  //     if (selectedBank === "bank3") {
  //       const payload = {
  //         pipe:selectedBank
  //       }
  //       const res = await sendAepsOtpMerchant(payload);

  //       if (res.success) {
  //         notify(res?.message || "OTP Sent Successfully", "success");
  //         setOtpTimerActive(true); 
  //         await fetchAepsOnboardData();
  //       }
  //       else {
  //   notify(res.message || "OTP failed", "error"); // ✅ failure case notify
  // }

  //       return;
  //     }

  //      if (selectedBank === "bank5") {
  //       setShowBank5Modal(true);
  //       return;
  //     }

  //     const location = savedLocation || (await getLocation());
  //     const pidData = await captureFingerprint();

     

  //     await finalActivateAeps(pidData, location, selectedBank);
  //   } catch {
  //     notify("KYC Failed", "error");
  //   } finally {
  //     setActionLoading(false);
  //   }
  // };
 const handleSendAepsOtp = async () => {
 if (!selectedBank) return notify("Select Bank", "error");

  try {
    setActionLoading(true);

 
    const bankKyc = onboard?.banks?.[selectedBank]?.kyc;

    if (normalizeBank(selectedBank) === "bank3" && !bankKyc?.otpVerified)

           {
        const res = await sendAepsOtpMerchant({ pipe: selectedBank });
        if (!res.success) return notify(res.message, "error");

        // Save bank & mobile in sessionStorage
        sessionStorage.setItem("aepsOtpBank", selectedBank);
        sessionStorage.setItem("aepsOtpMobile", userInfo.phone);

        notify(res.message || "OTP Sent", "success");

        // redirect to OTP page
        return navigate(
          `/aeps/otp-verify/${selectedBank}?mobile=${userInfo.phone}`
        );
      }

    // ================= BANK1 OTP + FP =================
   
       if (normalizeBank(selectedBank) === "bank1")

         {
        const location = savedLocation || (await getLocation());
        if (!location) return notify("Location Required", "error");

        const res = await aepsRegistration({
          pipe: selectedBank?.toLocaleLowerCase(),
          latitude: location.latitude,
          longitude: location.longitude,
        });
        if (!res.success) return notify(res.message, "error");

        const token = res.data?.otpToken;
        if (!token) return notify("OTP Token Missing", "error");

        // Save bank, mobile & OTP token in sessionStorage
        sessionStorage.setItem("aepsOtpBank", selectedBank);
        sessionStorage.setItem("aepsOtpMobile", userInfo.phone);
        sessionStorage.setItem("aepsOtpToken", token);

        notify("OTP Sent Successfully", "success");

        return navigate(
          `/aeps/otp-verify/${selectedBank}?mobile=${userInfo.phone}`
        );
      }
   
   


    // ================= BANK5 CUSTOM MODAL =================
     if (normalizeBank(selectedBank) === "bank5") {
      return setShowBank5Modal(true);
    }

    // ================= DEFAULT BIOMETRIC =================
    const location = savedLocation || (await getLocation());
    const pidData = await captureFingerprint(selectedBank);
    await finalActivateAeps(pidData, location, selectedBank);

  } catch (e) {
    console.error(e);
    notify("KYC Failed", "error");
  } finally {
    setActionLoading(false);
  }
};






  // ================= BANK5 EXTRA =================
const handleBank5Submit = async () => {
  // Validation
  if (!annualIncome || !natureBusiness) {
    return notify("Please fill all fields", "error");
  }
 setShowBank5Modal(false);
  try {
    const location = savedLocation || (await getLocation());
    if (!location) return notify("Location required", "error");

    const pidData = await captureFingerprint(selectedBank?.trim().toLowerCase());
    if (!pidData) return notify("Fingerprint capture failed", "error");

    await finalActivateAeps(pidData, location,selectedBank, {
      annual_income: annualIncome,
      nature_of_bussiness: natureBusiness,
 
    });

    setShowBank5Modal(false); // ✅ Close modal only after successful submit
  } catch (err) {
    console.error(err);
    notify("Activation failed", "error");
  }
};


  // ================= FINAL ACTIVATE =================
  const finalActivateAeps = async (pidData, location, pipe, extra = {}) => {
    try {
      const res = await activateAeps({
        pidData,
        latitude: location?.latitude,
        longitude: location?.longitude,
        pipe,
        ...extra,
      });

      if (res.success) {
        notify(res.message || "AEPS Activated", "success");
        dispatch(updateUserInfo({ aepsStatus: "ACTIVE" }));
        await fetchAepsOnboardData();
      } else notify(res.message, "error");
    } catch {
      notify("Activation Failed", "error");
    }
  };

  // INIT



  useEffect(() => {
  if (!openOtp) return;

  const interval = setInterval(() => {
    setTimer(t => {
      if (t <= 1) {
        clearInterval(interval);
        setOpenOtp(false);
        notify("OTP Expired", "error");
        return 0;
      }
      return t - 1;
    });
  }, 1000);

  return () => clearInterval(interval);
}, [openOtp]);

useEffect(() => {
  const token = sessionStorage.getItem("aepsOtpToken");
  const bank = sessionStorage.getItem("aepsOtpBank");

  if (token && bank === "bank1") {
    setOpenOtp(true);
    setTimer(120);
  }
}, []);


useEffect(() => {
fetchAepsOnboardData()
}, []);




useEffect(() => {
  const bankKyc = onboard?.banks?.[selectedBank]?.kyc;
  if (!bankKyc?.otpReqId || bankKyc?.otpVerified) return; // already verified, do nothing

  setOtpTimerActive(true);

  const timer = setTimeout(() => {
    notify("OTP Expired", "error");
    setOtp("");
    setOtpTimerActive(false);
  }, 5 * 60 * 1000);

  return () => clearTimeout(timer);
}, [onboard?.banks, selectedBank]);



  return (

<Main>
  <div className="ds-card w-full max-w-4xl mx-auto p-4 md:p-6 font-poppins">

           <div className="ds-card text-center">
          <h5 className="font-bold text-lg md:text-2xl text-[var(--text-dark)]">AEPS Dashboard</h5>
          <p className="text-sm md:text-base text-[var(--text-muted)] mt-1">
            Secure Fintech Merchant Panel
          </p>
        </div>

        {/* USER INFO */}
        <div className="flex flex-col md:flex-row gap-4 mt-4">
          {/* Partner Info */}
          <div className="ds-card flex flex-1 items-center gap-3 !p-3">
            <Avatar sx={{ width: 72, height: 72 }} className="border-2 border-[var(--primary-color)]" />
            <div>
              <p className="font-bold text-[var(--text-dark)]">{onboard?.partnerId}</p>
              <p className="text-sm text-[var(--text-muted)]">TxnId: {onboard?.onboard?.txnId}</p>
              <p className="text-sm text-[var(--text-muted)]">Request Id: {onboard?.onboard?.requestId}</p>
            </div>
          </div>

          {/* User Info */}
          <div className="ds-card flex flex-1 items-center gap-3 !p-3">
            <Avatar sx={{ width: 72, height: 72 }} className="border-2 border-[var(--primary-color)]" />
            <div>
              <p className="font-bold text-[var(--text-dark)]">{userInfo?.name}</p>
              <p className="text-sm text-[var(--text-muted)]">Merchant ID: {userInfo?.userName}</p>
              <p className="text-sm text-[var(--text-muted)]">Mobile: {userInfo?.phone}</p>
            </div>
          </div>
        </div>

        {/* PAGE HEADER / BANK SELECT */}
{/* <Box className="mt-4">

  <PageHeader
    banks={onboard?.paysprintbank || {}}
    title="Select Bank"
    selectedBank={selectedBank}
    setSelectedBank={handleBankChange} // slug change handle karega
    className="w-full"
  />

  {flow.onboard && (
    <Box className="mt-3">
      <Button
        fullWidth
        variant="contained"
        className="bg-indigo-500 hover:bg-indigo-600 text-white rounded-xl px-4 py-3 font-semibold shadow-md transition-all"
        sx={{
          width: "100%",
        }}
        onClick={handleStartOnboarding}
      >
        Start Onboarding
      </Button>
    </Box>
  )}
</Box> */}


{/* PAGE HEADER / BANK SELECT */}
<div className="mt-4">
  {flow.onboard ? (
    <>
      {/* Bank Buttons */}
      <PageHeader
        banks={onboard?.paysprintbank || {}}
        title="Select Bank"
        selectedBank={selectedBank}
        setSelectedBank={handleBankChange} // slug change handle karega
        className="w-full"
      />

      {/* Start Onboarding Button for selected bank flow */}
      {selectedBank && !bankKyc?.status && (
        <div className="mt-3">
          <button
            type="button"
            className="ds-btn ds-btn-primary w-full px-4 py-3"
            onClick={handleStartOnboarding}
          >
            Start {selectedBank.toUpperCase()} Flow
          </button>
        </div>
      )}
    </>
  ) : (
    // Only onboarding button if onboarding not yet done
    <div className="mt-3">
      <button
        type="button"
        className="ds-btn ds-btn-primary w-full px-4 py-3"
        onClick={handleStartOnboarding}
      >
        Start Onboarding
      </button>
    </div>
  )}
</div>





  {selectedBank  && (
          <div className="ds-card mt-3">
        

            {onboard?.banks?.[selectedBank]?.kyc?.status === "SUCCESS" && (
              <p className="text-[var(--text-muted)] text-sm">
                KYC Completed - OTP Verified: {onboard.banks[selectedBank].kyc.otpVerified ? "Yes" : "No"}
              </p>
            )}

            {onboard?.banks?.[selectedBank]?.registration?.status === "SUCCESS" && (
              <p className="text-[var(--text-muted)] text-sm">Device Registered</p>
            )}

            {onboard?.banks?.[selectedBank]?.onboardStatus === "SUCCESS" && (
              <p className="text-[var(--text-muted)] text-sm">Bank Onboarded Successfully</p>
            )}

            {!onboard?.banks?.[selectedBank]?.kyc?.status &&
              !onboard?.banks?.[selectedBank]?.registration?.status && (
                <button
                  type="button"
                  className="ds-btn ds-btn-primary mt-2 px-4 py-2"
                  onClick={handleStartOnboarding}
                >
                  Start {selectedBank.toUpperCase()} Flow
                </button>
              )}
          </div>
        )}

{/* {flow.onboard && (
  <Grid container spacing={2} mt={2} >
    

    <Grid item xs={6}>
      {flow.kyc ? (
        <Button
          fullWidth
          disabled
          className="bg-green-500 text-white font-semibold rounded-xl"
        >
          KYC Completed
        </Button>
      ) : (
        <Button
          fullWidth
          variant="contained"
          className="bg-yellow-400 hover:bg-yellow-500 text-black font-semibold rounded-xl"
          onClick={handleSendAepsOtp}
        >
          Start eKYC
        </Button>
      )}
    </Grid>


    <Grid item xs={6}>
      {flow.register ? (
        <Button
          fullWidth
          disabled
          className="bg-green-500 text-white font-semibold rounded-xl"
        >
          Device Registered
        </Button>
      ) : (
        <Button
          fullWidth
          variant="contained"
          className="bg-cyan-400 hover:bg-cyan-500 text-black font-semibold rounded-xl"
          onClick={handleStartRegistration}
        >
          Register Device
        </Button>
      )}
    </Grid>


    <Grid item xs={6}>
      <Button
        fullWidth
        variant="outlined"
      
        onClick={handleStatusCheck}
        className="rounded-xl"
      >
        Status  Check
      </Button>
    </Grid>


    <Grid item xs={6}>
      <Button
        fullWidth
        variant="outlined"
        startIcon={<Assessment />}
        onClick={handleStartAuth}
        className="rounded-xl"
      >
        Auth Check
      </Button>
    </Grid>

  </Grid>
)} */}

{flow.onboard && (
  <div className="grid grid-cols-2 gap-3 mt-4">
    <div>
  {/* BANK3 SPECIAL FLOW */}
  {normalizeBank(selectedBank) === "bank3" ? (
    bankKyc?.kycTxnId ? (
      <button
        type="button"
        disabled
        className="ds-btn w-full font-semibold"
        style={{ background: "var(--success-color)", color: "#fff" }}
      >
        ✅ Activated
      </button>
    ) : bankKyc?.otpVerified ? (
      <button
        type="button"
        onClick={handleSendAepsOtp}
        className="ds-btn ds-btn-primary w-full font-semibold"
      >
        OTP Verified → Activate Now
      </button>
    ) : (
      <button
        type="button"
        className="ds-btn ds-btn-secondary w-full font-semibold"
        onClick={handleSendAepsOtp}
        disabled={actionLoading}
      >
        {actionLoading && selectedBank === bankKyc?.pipe
          ? "Processing..."
          : "Start eKYC"}
      </button>
    )
  ) : (
    /* ALL OTHER BANKS */
    bankKyc?.kycTxnId ? (
      <button
        type="button"
        disabled
        className="ds-btn w-full font-semibold"
        style={{ background: "var(--success-color)", color: "#fff" }}
      >
        ✅ Activated
      </button>
    ) : (
      <button
        type="button"
        className="ds-btn ds-btn-secondary w-full font-semibold"
        onClick={handleSendAepsOtp}
        disabled={actionLoading}
      >
        {actionLoading && selectedBank === bankKyc?.pipe
          ? "Processing..."
          : "Start eKYC"}
      </button>
    )
  )}
</div>


    {/* Register Device Button */}
    <div>
      {flow.register ? (
        <button
          type="button"
          disabled
          className="ds-btn w-full font-semibold"
          style={{ background: "var(--success-color)", color: "#fff" }}
        >
          Device Registered
        </button>
      ) : (
        <button
          type="button"
          className="ds-btn ds-btn-primary w-full font-semibold"
          onClick={handleStartRegistration}
          disabled={actionLoading}
        >
          {actionLoading && !flow.register ? "Processing..." : "Register Device"}
        </button>
      )}
    </div>

    {/* Status Check */}
    <div>
      <button
        type="button"
        onClick={handleStatusCheck}
        className="ds-btn ds-btn-secondary w-full"
      >
        Status Check
      </button>
    </div>

    {/* Auth Check */}
    <div>
      <button
        type="button"
        onClick={handleStartAuth}
        className="ds-btn ds-btn-secondary w-full"
      >
        <Assessment fontSize="small" />
        Auth Check
      </button>
    </div>
  </div>
)}



    {/* MODALS */}


    {/* <OtpModal open={showOtpPopup} otp={otp} setOtp={setOtp} onVerify={handleVerifyOtp} /> */}
{/* <OtpModal 
  open={showOtpPopup || openOtp}
  otp={otp}
  timer={timer}
  setOtp={setOtp}
  onVerify={handleVerifyOtp}
/> */}

    <Bank5Modal
      open={showBank5Modal}
      onClose={() => setShowBank5Modal(false)}
      annualIncome={annualIncome}
      setAnnualIncome={setAnnualIncome}
      natureBusiness={natureBusiness}
      setNatureBusiness={setNatureBusiness}
      onSubmit={handleBank5Submit}
    />
  </div>
      <FingerprintModal open={fingerLoading} />
</Main>



  );
};

export default AEPSDashboard;
